<template>
  <el-container
    id="confirmacion"
    style="justify-content: center"
    v-loading.fullscreen.lock="loading"
  >
    <el-col
      class="main-wrapper"
      :xs="22"
      :sm="21"
      :md="14"
      :lg="12"
      :xl="12"
    >
      <el-row
        type="flex"
        justify="center"
      >
        <el-col
          :xs="24"
          :sm="16"
          :md="14"
          :lg="12"
          :xl="12"
          class="top-caption"
        >
          <p class="payment">
            PAGO DEL IMPUESTO PREDIAL EN LÍNEA
          </p>
          <p class="thanks" v-if="params.success">
            Gracias por realizar su pago
          </p>
        </el-col>
      </el-row>
      <br>
      <br>
      <el-row
        type="flex" justify="center"
      >
        <el-col v-if="params.success" class="col-flex-center">
          <p class="caption">
            {{ params.nbResponse }}
          </p>
          <i class="el-icon-success" />
          <b><p>Operación realizada con éxito</p></b>
        </el-col>
        <el-col v-else class="col-flex-center">
          <p class="caption">
            {{ params.nbResponse }}
          </p>
          <br>
          <i class="el-icon-error" />
          <br>
          <b><p>{{ params.nbError }}</p></b>
        </el-col>
      </el-row>
      <br>
      <el-row
        type="flex" justify="center"
        v-if="params.success"
      >
        <el-col
          :xs="16"
          :sm="10"
          :md="10"
          :lg="10"
          :xl="10"
          class="col-24-on-xs"
        >
          <el-row type="flex" justify="center">
            <el-col>
              <b><p>Referencia:</p></b>
            </el-col>
            <el-col style="text-align: end">
              <p>{{ params.referencia }}</p>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-col>
              <b><p>Autorización:</p></b>
            </el-col>
            <el-col style="text-align: end">
              <p>{{ params.nbAuth }}</p>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <br>
      <br>
      <el-row
        type="flex" justify="center"
        class="hide-on-print"
      >
        <el-col
          :md="8"
          :sm="12"
        >
          <p style="text-align: center; font-size: 14px">
            <b>Volver a página de inicio</b>
          </p>
          <br>
          <el-button :loading="loading" class="back-btn" @click="$router.push('/busqueda-del-predio')">
            Salir
          </el-button>
        </el-col>
      </el-row>
      <br>
      <el-row
        type="flex" justify="center"
        class="hide-on-print"
        v-if="params.success"
      >
        <el-col
          :md="8"
          :sm="12"
        >
          <el-button
            :loading="loading"
            @click="getRecibo"
            style="width: 100%;
              background-color: rgb(185, 165, 203);
              color: #FFFFFF;"
          >
            Imprimir recibo
          </el-button>
        </el-col>
      </el-row>
      <br>
      <el-row type="flex" justify="center">
        <el-col
          :sm="16" :md="14"
          style="text-align:center; font-size: 11px"
        >
          <p>
            DIRECCIÓN DE INGRESOS
          </p>
          <p>
            UNIDAD ADMINISTRATIVA BASÍLICA, 2DO NIVEL, OFICINA 22
          </p>
          <p>
            CENTROHISTÓRICO, ZAPOPAN JALISCO
          </p>
          <p>
            38182200 EXT. 2060, 2061, 2055
          </p>
        </el-col>
      </el-row>
    </el-col>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      params: {},
      loading: false,
      counter: 0,
    };
  },
  methods: {
    async getRecibo() {
      try {
        this.loading = true;
        const { referencia } = this.params;
        const id = referencia.slice(3, -10);
        const resRecibo = await this.axios.get(`/InformacionReciboCNA/${id}`);
        const reciboPDF = resRecibo.data.recibo;
        this.$store.dispatch('receipt/SET_DATA', { tipo: 'certificado-no-adeudos', reciboPDF });
        this.loading = false;
        this.$router.push({ path: 'recibo-pdf' });
      } catch (err) {
        if (err?.response?.status === 404) {
          if (this.counter < 40) {
            this.counter++;
            setTimeout(this.getRecibo, 15000);
          } else {
            this.$ErrorNotify({
              response: {
                data: {
                  alerta: 'Ha ocurrido un error generando el recibo, por favor intentelo más tarde.',
                },
              },
            });
            this.loading = false;
          }
        } else {
          this.$ErrorNotify(err);
          this.loading = false;
        }
      }
    },
  },
  mounted() {
    const query = this.$route.query;
    console.log(query);
    const regex = /aprobado|approved/i;
    this.params = {
      nbResponse: query.nb_response,
      referencia: query.c_refer,
      nbAuth: query.nb_auth,
      ndOrder: query.nd_order,
      nbError: query.nb_error,
      success: regex.test(query.nb_response),
    };
  },
};
</script>

<style lang="scss" scoped>
  .main-wrapper {
    padding: 40px 0;
    .back-btn {
      width: 100%;
      & a {
        text-decoration: none !important;
        color: #000000 !important;
      }
    }
    .top-caption {
      text-align: center;
      .payment {
        text-align: center;
        font-size: 16pt;
        font-weight: bold;
      }
      .thanks {
        font-size: 14pt;
        font-weight: bold;
        color: #ffffff;
        background-color: #C9237E;
        padding: 10px;
      }
    }

    .col-flex-center {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .caption {
      text-align: center;
      font-weight: bold;
      font-size: 18px;
    }
    .el-icon-error, .el-icon-success {
      font-size: 120px;
    }

    .el-icon-success {
      color: #4BB543;
    }

    .el-icon-error {
      color: #CC3300;
    }
  }

  @media only screen and (max-width: 450px) {
    .col-24-on-xs {
      width: 100% !important;
    }
  }
</style>

<style>
@media print {
  .header, .hide-on-print {
    display: none;
  }
}
</style>
